/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterNoticeDto } from '../../models/center-notice-dto';

export interface CenterNoticeControllerFindAll$Params {
}

export function centerNoticeControllerFindAll(http: HttpClient, rootUrl: string, params?: CenterNoticeControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterNoticeDto>>> {
  const rb = new RequestBuilder(rootUrl, centerNoticeControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterNoticeDto>>;
    })
  );
}

centerNoticeControllerFindAll.PATH = '/api/center-notice/center';
